import { render, staticRenderFns } from "./BilletExcelFileDetailCard.vue?vue&type=template&id=4c32ad6a&scoped=true"
import script from "./BilletExcelFileDetailCard.vue?vue&type=script&lang=js"
export * from "./BilletExcelFileDetailCard.vue?vue&type=script&lang=js"
import style0 from "./BilletExcelFileDetailCard.vue?vue&type=style&index=0&id=4c32ad6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32ad6a",
  null
  
)

export default component.exports